import React from 'react';
import { Button, ConfigProvider, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Layout/Navbar';
import bgVideo from '../../assets/video.mp4';
import './HomePage.css';
import { RightOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';

const { Content } = Layout;

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleStartClick = async () => {
    navigate('/main');
  };

  return (
    <ConfigProvider
    >
      <Layout className="home-layout">
        <Navbar />
        {/* Background Video */}
        <div className="background-video-wrapper" aria-hidden="true">
            <video
            className="background-video"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            style={{ backgroundColor: 'rgba(239, 221, 186, 1)' }}
            >
            <source src={bgVideo} type="video/mp4" />
            Your browser does not support the video tag.
            </video>
          <div className="video-overlay" />
        </div>
        <Content className="home-content">
          <div className="hero-section">
            <div className="hero-text">
              <p className="title">Digital Transfomation Blueprint</p>

              <div className="main-logo">
                <h1>SCG CEMENT</h1>
                {/* Glass Object positioned behind SCG text */}
                {/* <div className="glass-obj">
                  <div className="glass-rectangle"></div>
                  <div className="glass-mask"></div>
                  <div className="glass-text">SCG</div>
                  <div className="glass-ellipse"></div>
                </div> */}
              </div>

              <p className="sub-title">Shaping The Future Of Cement Manufacturing</p>
                <Button
                  type="primary"
                  size="large"
                  className="start-button"
                  onClick={handleStartClick}
                  icon={
                    <div style={{
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      width: '24px',
                      height: '24px',
                    }}>
                      <RightOutlined/>
                    </div>
                  }
                  iconPosition='end'
                  style={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  {language === 'TH' ? 'เริ่มต้น' : 'Get Started'}
                </Button>
            </div>
          </div>
        </Content>
      </Layout>
    </ConfigProvider>
  );
};

export default HomePage;
